import gsap from "gsap";

let bodyEl:HTMLElement|null;


function initHelper() {
  bodyEl = document.querySelector('html');
}

export function enableScrollingForOverlay() {
  bodyEl?.classList.remove('scrolling');
}

export function disableScrollingForOverlay() {
  bodyEl?.classList.add('scrolling');
}

document.addEventListener('DOMContentLoaded', () => {
  initHelper();
})